<template>
  <div class="right-nav">
    <ul>
      <li class="right-nav-item">
        <div class="right-nav-item-content" @click="top()">
          <img :src="imgIcon" class="icon_style" alt="">
          <span class="topStyle">Top</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgIcon: '../../../static/img/formIcons/backTopB.png'
    };
  },
  methods: {
    top() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.top);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
ul {
  list-style: none;
}

ul li {
  width: 40px;
  height: 50px;
  text-align: center;
  padding: 8px 3px;
  color: #fff;
  cursor: pointer;

  img {
    display: block;
  }

  span {
    display: none;
  }
}

ul li :hover {
  background-color: #409EFF;
  color: $color-main;
  border-color: #409EFF;

  img {
    display: none;
  }

  span {
    display: block;
    font-size: 18px;
    padding: 10px 3px;
  }
}

.icon_style {
  margin-left: -3px;
  margin-top: -2px;
}

.icon_style:before {
  content: '\e605';
  color: #fff;
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/common/area/enElevator.vue